/**
 * Mostra "NPTS actuais + faltam X para próximo pin (Y%)".
 *
 * Usa a mesma escala `Tdom_BonusGroup` do backend
 * (0–149: 0%, 150–600: 4%, 601–1500: 8%, 1501–4200: 12%,
 *  4201–7500: 16%, 7501+: 20%).
 *
 * Props:
 *   - npts {number}: NetPointsTotal actuais (mês corrente)
 *   - mesLabel {string?}: ex. "Mai 2026" (opcional)
 *   - compact {boolean?}: variante mais pequena para Card
 */
import React from "react";

const NPTS_TIERS = [
  { min:    0, bonus:  0, nivel: "—" },
  { min:  150, bonus:  4, nivel: "IHTP 1★" },
  { min:  601, bonus:  8, nivel: "IHTP 2★" },
  { min: 1501, bonus: 12, nivel: "IHTP 3★" },
  { min: 4201, bonus: 16, nivel: "IHTP 4★" },
  { min: 7501, bonus: 20, nivel: "TOP" },
];

function fmt(n) {
  return Number(n).toLocaleString("pt-PT", { maximumFractionDigits: 0 });
}

export function NextPinHint({ npts, mesLabel, compact }) {
  const value = Number(npts || 0);
  const currentTier = [...NPTS_TIERS].reverse().find((t) => value >= t.min) || NPTS_TIERS[0];
  const nextTier = NPTS_TIERS.find((t) => t.min > value);

  if (compact) {
    return (
      <div className="text-[10px] text-[#6B7280] leading-snug mt-1" data-testid="next-pin-hint-compact">
        {nextTier ? (
          <>
            Faltam <b className="font-mono text-[#0F1829]">{fmt(nextTier.min - value)}</b> NPTS
            {" → "}{nextTier.nivel} ({nextTier.bonus}%)
          </>
        ) : (
          <>Está no nível máximo (TOP · 20%).</>
        )}
      </div>
    );
  }

  return (
    <div className="bg-[#F9FAFB] border border-[#E5E7EB] rounded-md px-3 py-2 text-[11px] leading-relaxed"
         data-testid="next-pin-hint">
      <span className="text-[#6B7280]">
        NetPoints actuais{mesLabel ? ` (${mesLabel})` : ""}:
        {" "}<b className="font-mono text-[#0F1829]">{fmt(value)}</b>
        {" · "}nível <b>{currentTier.nivel}</b> ({currentTier.bonus}%)
      </span>
      {nextTier ? (
        <span className="ml-1 text-[#0F1829]">
          {" · "}Faltam{" "}
          <b className="font-mono">{fmt(nextTier.min - value)}</b> NPTS para{" "}
          <b>{nextTier.nivel}</b> ({nextTier.bonus}%).
        </span>
      ) : (
        <span className="ml-1 text-emerald-700">{" · "}Está no nível máximo (TOP · 20%).</span>
      )}
    </div>
  );
}

export default NextPinHint;
